import { mutationOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type { ScriptFissionTaskDto } from '../task/model';
import type { FissionInputDto } from './model';

export const fissionScriptMutationOptins = mutationOptions({
  mutationFn: async (input: FissionInputDto) => {
    const data = await http
      .post('script/image/analysis', {
        json: input,
      })
      .json<ScriptFissionTaskDto>();

    return data;
  },
});
